var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"size":"small"},on:{"close":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("Edit "+_vm._s(_vm.age.text))])])]),_vm._v(" "),_c('Form',{attrs:{"age":_vm.age},on:{"close":function($event){return _vm.$emit('close')}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77828c38","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Age/Edit.vue
// module id = 595
// module chunks = 0